import React from 'react';
import { useTranslation } from 'react-i18next';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { FlexLayoutProps } from '@swyftx/aviary/atoms/Layout/Flex/FlexLayout.styles';
import { Tooltip } from '@swyftx/aviary/atoms/Tooltip/Tooltip';
import { Body, Numeric } from '@swyftx/aviary/atoms/Typography';
import { MarginOrderDirection } from '@swyftx/margin/build/types';

import { Big } from '@shared/safe-big';
import { formatCurrency } from '@shared/utils';
import { cn } from '@shared/utils/lib/ui';

type Props = {
  title: string;
  value: Big;
  tabValue: MarginOrderDirection;
  loading?: boolean;
  disabled?: boolean;
  alignItems?: FlexLayoutProps['alignItems'];
  tradeSide: MarginOrderDirection;
  priceScale?: number;
  setSide: (tradeSide: MarginOrderDirection) => void;
};

const MarginTradePanelBuySellTab: React.FC<Props> = ({
  alignItems,
  loading,
  tabValue,
  title,
  value,
  disabled = false,
  tradeSide,
  priceScale,
  setSide,
}) => {
  const { t } = useTranslation('margin');

  return (
    <Tooltip title={disabled ? t(`tradePanel.disabledTooltips.${tabValue}`) : ''}>
      <FlexLayout
        className={cn('z-10 h-full w-1/2  p-8', disabled ? 'cursor-not-allowed' : 'cursor-pointer')}
        direction='column'
        alignItems={alignItems}
        justifyContent='center'
        spacing={4}
        onClick={() => !disabled && setSide(tabValue)}
      >
        <Body color={tradeSide === tabValue && !disabled ? 'inverse' : 'secondary'} weight='bold' size='medium'>
          {title}
        </Body>
        <Numeric color={tradeSide === tabValue && !disabled ? 'inverse' : 'secondary'} loading={loading} size='medium'>
          {formatCurrency(value, undefined, { priceScale })}
        </Numeric>
      </FlexLayout>
    </Tooltip>
  );
};

export { MarginTradePanelBuySellTab };
